export default __webpack_public_path__ + "static/media/copy.27c9ea9a.svg";